<template>
  <div class="container">
    <hr class="space space-xs">
    <router-link :to="{ name: 'chat' }" class="btn btn-primary mb-3"> <i class="fa fa-chevron-left"></i> Вернуться в чат</router-link>
    <loader v-if="isLoading"></loader>
    <div class="row py-5" v-else>
      <div class="col-md-12">
        <div class="d-flex align-items-center">
          <h1 class="h2 mb-4">
            <span v-if="publicUser.name == 'Renat Galyamov'">ЗАБУГОРЩИКИ</span>
            <span v-else-if="publicUser.name">{{ publicUser.name }}</span>
            <span v-else>{{ publicUser.firstName }} {{ publicUser.lastName }}</span>
          </h1>
          <router-link v-if="user.id === publicUser.id" class="btn btn-light mb-3 ml-3" :to="{ name: 'profile-edit' }">Редактировать</router-link>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <div class="border rounded">
          <div class="d-flex align-items-center">
            <div class="col-8">
              <p class="pt-4 h3">{{ totalDistance * 1000 }} м</p>
              <p class="mr-auto">Всего пройдено</p>
            </div>
            <div class="col-4 text-right">
              <img width="60" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/route.png" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <div class="border rounded">
          <div class="d-flex align-items-center">
            <div class="col-8">
              <p class="pt-4 h3">{{ totalElevation }} м</p>
              <p class="mr-auto">Общий набор высоты</p>
            </div>
            <div class="col-4 text-right">
              <img width="60" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/hiking.png" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <div class="border rounded">
          <div class="d-flex align-items-center">
            <div class="col-8">
              <p class="pt-4 h3">{{ totalDuration }} часов</p>
              <p class="mr-auto">Общее время в пути</p>
            </div>
            <div class="col-4 text-right">
              <img width="60" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/outdoor.png" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mb-3">
        <div class="border rounded">
          <div class="d-flex align-items-center">
            <div class="col-8">
              <p class="pt-4 h3">{{ messagesCount }}</p>
              <p class="mr-auto">Сообщений в чате</p>
            </div>
            <div class="col-4 text-right">
              <img width="60" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/friends.png" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '../UIComponents/Loader.vue'
export default {
  components: { Loader },
  name: 'PublicProfile',
  data () {
    return {
      isLoading: null,
      messagesCount: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      hikes: state => state.hikes.userHikes,
      publicUser: state => state.auth.publicUser
    }),
    totalDistance () {
      return Math.round(this.hikes.reduce((acc, hike) => acc + Number(hike.distance), 0) * 100) / 100
    },
    totalElevation () {
      return this.hikes.reduce((acc, hike) => acc + Number(hike.elevation), 0)
    },
    totalDuration () {
      return this.hikes.reduce((acc, hike) => acc + Number(hike.durationHours), 0)
    }
  },
  created () {
    this.isLoading = true
    this.getUser()
    this.getHikes()
  },
  methods: {
    getUser () {
      const userId = this.$route.params.id
      this.$store.dispatch('GET_PUBLIC_PROFILE', userId).then(response => {
        this.isLoading = false
        this.$nextTick(() => {
          this.$store.dispatch('GET_MESSAGES_COUNT_BY_USER', this.publicUser.id).then(response => {
            this.messagesCount = response
          })
        })
      })
    },
    getHikes () {
      const userId = this.$route.params.id
      this.$store.dispatch('GET_USER_HIKES', userId)
    }
  }
}
</script>